export default __webpack_public_path__ + "static/blog-404-plans-desktop-d1c7e44f5513ec68f92c94a8ad76b36b.png";